import * as analytics from '../../utils/analytics'

export const pageViewEvent = href => {
  const path = href.substring(href.indexOf('/journeys/'))
  analytics.track('productJourneyPageViewed', {
    contentType: 'ProductStory',
    path
  })
  analytics.track('productJourneyPage_viewed', {
    object: 'productJourneyPage',
    action: 'viewed',
    contentType: 'productStory'
  }, { adapter: 'segment' })
}

export const linkSelected = (linkName, analyticsContext) => {
  analytics.track('click_link', {
    link: linkName,
    eventAction: linkName,
    eventLabel: analyticsContext
  }, { adapter: 'gtm' })

  analytics.track('link_clicked', {
    object: 'link',
    action: 'clicked',
    link_label: linkName,
    event_label: analyticsContext
  }, { adapter: 'segment' })
}
